<template>
  <UserNotifications :notifications="notifications" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useSubscription } from '@vue/apollo-composable';
import { useMessagesStore } from '@/store/useMessagesStore';
import { useAuth, useSentry } from '@/composables';
import UserNotifications from './UserNotifications.vue';
import { UserNotifiedDocument } from './UserNotificationsContainer.generated';

const auth = useAuth();
const sentry = useSentry();
const messagesStore = useMessagesStore();

const notifications = computed(() => messagesStore.alerts);

const statusToColorClassMap: Record<string, string> = {
  INFO: 'info',
  WARNING: 'warning',
  SUCCESS: 'valid',
  FAILURE: 'invalid',
};

function convertNotificationStatusToColorClass(status: string) {
  try {
    if (!statusToColorClassMap[status]) {
      throw new Error(`Invalid param value [status='${status}']`);
    }
    return statusToColorClassMap[status];
  } catch (err) {
    sentry.captureException(err);
    return 'info';
  }
}

const { onResult } = useSubscription(UserNotifiedDocument, null, () => ({
  enabled: !!auth.loggedUser,
}));

onResult(({ data }) => {
  if (!data) return;
  const { id, status, message } = data.userNotified;
  messagesStore.pushFlashMessage({
    id,
    message,
    colorClass: convertNotificationStatusToColorClass(status),
  });
});
</script>
